import { Router } from '@angular/router';
import {Injectable, Injector, NgZone} from '@angular/core';
import * as fromStore from '../store';
import { Store } from '@ngrx/store';
import { UserService } from '../../app/services/user.service';

const MINUTES_UNITL_AUTO_LOGOUT = 60; // in Minutes
const CHECK_INTERVALL = 1000; // in ms
const STORE_KEY = 'lastAction';
@Injectable()
export class AutoLogoutService {
isLogIn: boolean;
  constructor(
    private router: Router,
    private ngZone: NgZone,
    private store: Store<fromStore.State>,
    private injector: Injector,
    private userService: UserService,
  ) {
    this.check();
    this.initListener();
    this.initInterval();
    this.store.select(fromStore.getIsLogin).subscribe(res => {
      this.isLogIn = res;
    });
  }

  get lastAction() {
    return parseInt(localStorage.getItem(STORE_KEY), 10);
  }

  set lastAction(value: number) {
    localStorage.setItem(STORE_KEY, String(value));
  }

  initListener() {
    this.ngZone.runOutsideAngular(() => {
      document.body.addEventListener('click', () => this.reset());
    });
  }

  initInterval() {
    this.ngZone.runOutsideAngular(() => {
      setInterval(() => {
        this.check();
      }, CHECK_INTERVALL);
    });
  }

  reset() {
    this.lastAction = Date.now();
  }

  check() {
    const now = Date.now();
    const timeleft = this.lastAction + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;

    this.ngZone.run(() => {
      if (isTimeout && this.isLogIn) {
        console.log(`Time out.`);
        this.store.dispatch(new fromStore.LogoutAction());
        const router = this.injector.get(Router);
        this.userService.SetRedirect = null;
        // router.navigate(['/login']);
      }
    });
  }
}
